import { COOKIE_NAME, SESSION_TTL, WIX_DOMAINS } from '../constants';
import { isPolicyAllowsBsi } from '../lib/policy';
import { writeCookie, readCookie, destroyCookie, getNextLocalMidnight } from '../lib/utils';
let cookieDomain;
const cookiePath = '/';
const extractWixDomain = () => WIX_DOMAINS.reduce((res, domain) => {
  if (!res && window.document.location.hostname.indexOf(domain) !== -1) {
    return domain;
  }
  return res;
}, null);
const getCookieDomain = () => {
  if (!cookieDomain) {
    const wixDomain = extractWixDomain();
    cookieDomain = wixDomain || window.document.location.hostname;
  }
  return cookieDomain;
};
export class CookieStorage {
  constructor(configStorage, getCookieReaderWriter, options) {
    if (getCookieReaderWriter === void 0) {
      getCookieReaderWriter = () => ({
        read: readCookie,
        write: writeCookie,
        destroy: destroyCookie
      });
    }
    if (options === void 0) {
      options = {};
    }
    this.configStorage = configStorage;
    this.getCookieReaderWriter = getCookieReaderWriter;
    this.options = options;
  }
  checkPolicyAndDestroyIfNeeded() {
    if (!isPolicyAllowsBsi(this.configStorage.getPolicy())) {
      this.destroy();
      return false;
    }
    return true;
  }
  get() {
    if (!this.checkPolicyAndDestroyIfNeeded()) {
      return null;
    }
    return this.getCookieReaderWriter().read(COOKIE_NAME);
  }
  set(bsi) {
    if (!this.checkPolicyAndDestroyIfNeeded()) {
      return {
        bsi: null,
        ttl: null
      };
    }
    const now = Date.now();
    const expires = Math.min(now + SESSION_TTL, getNextLocalMidnight());
    const domain = this.options.cookieDomain ?? getCookieDomain();
    this.getCookieReaderWriter().write(COOKIE_NAME, `${bsi}`, expires, cookiePath, domain);
    return {
      bsi,
      ttl: expires - now
    };
  }
  destroy() {
    this.getCookieReaderWriter().destroy(COOKIE_NAME, cookiePath, this.options.cookieDomain ?? getCookieDomain());

    // Destroy local storage items set by the old bsi implementation in Santa
    try {
      window.localStorage.removeItem('beatSessionTs');
      window.localStorage.removeItem('beatSessionId');
    } catch (e) {}
  }
}
//# sourceMappingURL=cookie-storage.js.map